'use client';

import { cn } from '@/app/lib/utils';
import Icon from './Icon';

const Spinner = ({ className, size = 12 }: { className?: string; size?: number }) => {
  return (
    <div
      data-testid="spinner"
      className={cn(
        'absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center text-muted-foreground',
        className
      )}
    >
      <Icon name="loading" size={size} aria-label="Loading" />
    </div>
  );
};

export default Spinner;
